<template>
  <!-- 座位查询 -->
  <div class="seat_listbox">
    <div class="topbox">
      <h5>座位查询</h5>
      <van-search v-model="searchValue" placeholder="请输入姓名查询" @search="goSearch(searchValue)" />
      <van-button class="searchBtn" block @click="goSearch(searchValue)">查询</van-button>
    </div>
    <div class="s_list">
      <van-notice-bar v-if="text != ''" color="#1989fa" background="#ecf9ff" wrapable  :scrollable="false" left-icon="info-o" :text='text'>
     </van-notice-bar>
      <div class="seat_box">
        <van-row v-for="items2 in list2">
          <van-col span="10">
            <van-image class="imgbox" src="/static/images/member_default1.png" />
            <p>{{items2.name}}</p>
          </van-col>
          <van-col span="8" class="number">{{items2.tel}}</van-col>
          <van-col span="6" class="click iconfont" @click="goPath(items2)">查看座位&#xe633;</van-col>
        </van-row>
      </div>
    </div>
    <!--浮动按钮-->
    <template v-if="Object.keys(conference).length != 0">
        <footerFixed :id="id" :jump-page="conference.jump_page"/>
  </template>
    <van-popup v-model="!tips.is_search" position="top" :style="{ height: '100%' }">
      <van-empty image="search" :description="tips.search_tips" />
  </van-popup>
  </div>
</template>

<script>
  import {
    formatDates,
    formatWeekDate
  } from "@/assets/js/date";
  import footerFixed from  '@/components/common/fixed_setting'
  export default {
    components: {
      footerFixed
    },
    data() {
      return {
        id: '',
        conference: {},
        list: [],
        list2: [],
        text: '',
        footerNav: false,
        searchValue: '', //搜索内容
        tips:{
          is_search:true
        }
      };
    },
    /* 时间过滤 */
    filters: {
      formatDates, //调用方法formatTime(1575346406, 'Y年M月D日 h:m:s')
      formatWeekDate //
    },
    created: function() {
      var _this = this;
      _this.id = _this.$route.params.id;
      _this.getTips();
    },
    methods: {
      //打开底部链接
      openFooterNav(val) {
        if (this.footerNav) {
          this.footerNav = false;
        } else {
          this.footerNav = true;
        }
      },
      getTips(){
        var _this = this;
        let url = "/ac1/conference/seat/tips";
        let params = {
          id: _this.id
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            _this.tips = res.posts;
          } else {
            _this.$toast(res.msg);
          }
        }, function(res) {
          console.log(res.msg);
        });
      },
      goSearch(name) {
        var _this = this;
        if(!_this.tips.is_search){
          _this.text =  _this.tips.search_tips;
          return false;
        }
        if (name == '') {
          _this.$toast('请输入姓名查询!');
          return false;
        }
        if (name != _this.searchValue) {
          _this.searchValue = name;
        }
        let url = "/ac1/conference/seat/search";
        let params = {
          name: name,
          id: _this.id
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            if (res.posts.length >= 1) {
              _this.text = "查询到与“" + name + "”相关的用户有如下几个：";
              _this.list2 = res.posts;
            }  else {
              _this.list2 = [];
              _this.text =  _this.tips.tips;
            }
          } else {
            _this.$toast(res.msg);
          }
        }, function(res) {
          console.log(res.msg);
        });
      },
      goPath(item) {
        let _this = this;
        _this.$router.push('/mySeat/' + _this.id + '/' + item.numbered + "/" + item.line + '/' + item.column);
      }
    }
  };
</script>
